module.exports = __webpack_public_path__ + "img/yt_shorts.2c1f43e4.svg";